/* eslint-disable import/no-cycle */
import React from 'react';
import PropTypes from 'prop-types';
import { Divider, List } from '@mantine/core';
import AppStack from '../../../../../common/AppStack';
import AppText from '../../../../../common/AppText';

const WsProductCareInstructions = ({
  showAll,
  showApparel,
  showHats,
  showTotebags,
  showDrinkware,
  isSummaryView,
  hideTitle
}) => {
  const baseFontSize = isSummaryView ? 14 : 16;

  return (
    <AppStack style={{ gap: 25 }}>
      {showAll && (
        <>
          <AppStack style={{ gap: 5 }}>
            <AppText style={{ fontSize: 28, fontWeight: 500 }}>
              Product Care Instructions
            </AppText>

            <AppText style={{ fontSize: baseFontSize }}>
              To ensure the longevity of your printed designs and the overall
              quality of your product, please follow the care guidelines below.
              Proper care will help prevent fading, peeling, cracking, and
              premature wear.
            </AppText>
          </AppStack>

          <Divider />
        </>
      )}

      {(showApparel || showAll) && (
        <>
          <AppStack style={{ gap: 12 }}>
            {!hideTitle && (
              <AppText style={{ fontSize: 22, fontWeight: 500 }}>
                Printed Apparel (DTG-Printed Clothing)
              </AppText>
            )}

            <AppStack style={{ gap: 5 }}>
              <AppText style={{ fontSize: baseFontSize + 2, fontWeight: 500 }}>
                Important Notice
              </AppText>
              <AppText style={{ fontSize: baseFontSize }}>
                DTG garments are pre-treated to ensure high print quality. A
                slight residue or sheen may be visible before the first
                wash—this is normal and will disappear after initial laundering.
              </AppText>
              <AppText style={{ fontSize: baseFontSize, fontWeight: 500 }}>
                All DTG-printed garments must be washed before first use.
              </AppText>
            </AppStack>

            <Divider />

            <AppStack style={{ gap: 5 }}>
              <AppText style={{ fontSize: baseFontSize + 2, fontWeight: 500 }}>
                Washing Instructions
              </AppText>
              <List style={{ paddingRight: 20 }} withPadding>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Turn garment{' '}
                    <span style={{ fontWeight: 500 }}>inside out</span>
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Wash in <span style={{ fontWeight: 500 }}>cold water</span>{' '}
                    — max <span style={{ fontWeight: 500 }}>30°C / 86°F</span>
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Use a{' '}
                    <span style={{ fontWeight: 500 }}>delicate cycle</span>{' '}
                    (around 600 rpm)
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Use a{' '}
                    <span style={{ fontWeight: 500 }}>
                      mild, color-safe detergent
                    </span>
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    <span style={{ fontWeight: 500 }}>Avoid</span> bleach,
                    fabric softener, and harsh chemicals
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Do <span style={{ fontWeight: 500 }}>not</span> dry clean
                  </AppText>
                </List.Item>
              </List>
            </AppStack>

            <AppText style={{ fontSize: baseFontSize, fontStyle: 'italic' }}>
              These steps protect the printed design from fading, cracking, or
              peeling.
            </AppText>

            <Divider />

            <AppStack style={{ gap: 5 }}>
              <AppText style={{ fontSize: baseFontSize + 2, fontWeight: 500 }}>
                Drying Instructions
              </AppText>
              <List style={{ paddingRight: 20 }} withPadding>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Keep garment{' '}
                    <span style={{ fontWeight: 500 }}>inside out</span>
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    <span style={{ fontWeight: 500 }}>Hang to dry</span> for
                    best results OR Tumble dry on{' '}
                    <span style={{ fontWeight: 500 }}>low heat</span>
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Remove promptly after washing — leaving it wet may cause
                    image bleeding
                  </AppText>
                  <List
                    listStyleType="disc"
                    style={{ paddingRight: 20 }}
                    withPadding
                  >
                    <List.Item>
                      <AppText style={{ fontSize: baseFontSize }}>
                        If bleeding occurs,{' '}
                        <span style={{ fontWeight: 500 }}>
                          rewash immediately
                        </span>
                      </AppText>
                    </List.Item>
                  </List>
                </List.Item>
              </List>
            </AppStack>

            <AppStack style={{ gap: 5 }}>
              <AppText style={{ fontSize: baseFontSize + 2, fontWeight: 500 }}>
                Ironing
              </AppText>
              <List style={{ paddingRight: 20 }} withPadding>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Do <span style={{ fontWeight: 500 }}>not</span> iron
                    directly on the printed area
                  </AppText>
                </List.Item>
              </List>
            </AppStack>
          </AppStack>

          {(showAll || showHats || showDrinkware || showTotebags) && (
            <Divider />
          )}
        </>
      )}

      {(showHats || showAll) && (
        <>
          <AppStack style={{ gap: 12 }}>
            {!hideTitle && (
              <AppText style={{ fontSize: 22, fontWeight: 500 }}>Hats</AppText>
            )}

            <AppStack style={{ gap: 5 }}>
              <AppText style={{ fontSize: baseFontSize + 2, fontWeight: 500 }}>
                Washing Instructions
              </AppText>
              <List style={{ paddingRight: 20 }} withPadding>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    <span style={{ fontWeight: 500 }}>Spot clean</span> with
                    mild, diluted detergent before fully submerging.
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    <span style={{ fontWeight: 500 }}>Soak</span> for up to 15
                    minutes if needed.
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    <span style={{ fontWeight: 500 }}>Rinse</span> thoroughly in
                    cold or warm water.
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    <span style={{ fontWeight: 500 }}>Dry gently</span> by
                    patting with a towel, reshaping the hat, and letting it air
                    dry.
                  </AppText>
                </List.Item>
              </List>
            </AppStack>
          </AppStack>

          {(showAll || showDrinkware || showTotebags) && <Divider />}
        </>
      )}

      {(showDrinkware || showAll) && (
        <>
          <AppStack style={{ gap: 12 }}>
            {!hideTitle && (
              <AppText style={{ fontSize: 22, fontWeight: 500 }}>
                Mugs & Drinkware
              </AppText>
            )}

            <AppStack style={{ gap: 5 }}>
              <AppText style={{ fontSize: baseFontSize + 2, fontWeight: 500 }}>
                General Guidance
              </AppText>
              <AppText style={{ fontSize: baseFontSize }}>
                Please wash all drinkware before first use. For best results and
                to preserve printed designs, follow the care instructions
                specific to your item.
              </AppText>
            </AppStack>

            <Divider />

            <AppStack style={{ gap: 5 }}>
              <AppText style={{ fontSize: baseFontSize + 2, fontWeight: 500 }}>
                Ceramic & Porcelain Mugs
              </AppText>
              <List style={{ paddingRight: 20 }} withPadding>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize, fontWeight: 500 }}>
                    Hand wash only
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize, fontWeight: 500 }}>
                    Microwave safe
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Avoid abrasive sponges or harsh detergents
                  </AppText>
                </List.Item>
              </List>
            </AppStack>

            <AppStack style={{ gap: 5 }}>
              <AppText style={{ fontSize: baseFontSize + 2, fontWeight: 500 }}>
                Travel Mugs
              </AppText>
              <List style={{ paddingRight: 20 }} withPadding>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize, fontWeight: 500 }}>
                    Dishwasher safe — top rack only
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize, fontWeight: 500 }}>
                    Not microwave safe
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Avoid prolonged soaking
                  </AppText>
                </List.Item>
              </List>
            </AppStack>

            <AppStack style={{ gap: 5 }}>
              <AppText style={{ fontSize: baseFontSize + 2, fontWeight: 500 }}>
                Water Bottles, Steins & Enamel Drinkware
              </AppText>
              <List style={{ paddingRight: 20 }} withPadding>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize, fontWeight: 500 }}>
                    Hand wash only
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize, fontWeight: 500 }}>
                    Not microwave safe
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Do not use abrasive scrubbers on the printed area
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Avoid extremely hot water, which can weaken printed coatings
                  </AppText>
                </List.Item>
              </List>
            </AppStack>
          </AppStack>

          {(showAll || showTotebags) && <Divider />}
        </>
      )}

      {(showTotebags || showAll) && (
        <>
          <AppStack style={{ gap: 12 }}>
            {!hideTitle && (
              <AppText style={{ fontSize: 22, fontWeight: 500 }}>
                Tote Bags
              </AppText>
            )}

            <AppStack style={{ gap: 5 }}>
              <AppText style={{ fontSize: baseFontSize + 2, fontWeight: 500 }}>
                Washing Instructions
              </AppText>
              <List style={{ paddingRight: 20 }} withPadding>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Hand wash or machine wash in{' '}
                    <span style={{ fontWeight: 500 }}>cold water</span>
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Use a mild detergent
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Hang to dry only
                  </AppText>
                </List.Item>
              </List>
            </AppStack>

            <AppStack style={{ gap: 5 }}>
              <AppText style={{ fontSize: baseFontSize + 2, fontWeight: 500 }}>
                Caution
              </AppText>
              <List style={{ paddingRight: 20 }} withPadding>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Do <span style={{ fontWeight: 500 }}>not</span> bleach
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Do <span style={{ fontWeight: 500 }}>not</span> tumble dry
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Do <span style={{ fontWeight: 500 }}>not</span> iron
                  </AppText>
                </List.Item>
                <List.Item>
                  <AppText style={{ fontSize: baseFontSize }}>
                    Do <span style={{ fontWeight: 500 }}>not</span> dry clean
                  </AppText>
                </List.Item>
              </List>
            </AppStack>

            <AppText style={{ fontSize: baseFontSize, fontStyle: 'italic' }}>
              Following these steps helps prevent print distortion and fabric
              shrinkage.
            </AppText>
          </AppStack>

          {showAll && <Divider />}
        </>
      )}

      {showAll && (
        <AppStack style={{ gap: 5 }}>
          <AppText style={{ fontSize: 22, fontWeight: 500 }}>
            Why Proper Care Matters
          </AppText>

          <AppText style={{ fontSize: baseFontSize }}>
            Improper washing or exposure to high heat can cause designs to fade,
            crack, or peel prematurely. Following the guidelines above will help
            maintain the vibrancy and durability of your product for as long as
            possible.
          </AppText>
        </AppStack>
      )}
    </AppStack>
  );
};

WsProductCareInstructions.propTypes = {
  hideTitle: PropTypes.bool,
  isSummaryView: PropTypes.bool,
  showAll: PropTypes.bool,
  showApparel: PropTypes.bool,
  showDrinkware: PropTypes.bool,
  showHats: PropTypes.bool,
  showTotebags: PropTypes.bool
};

export default WsProductCareInstructions;
